export const API_ERROR_CODES_MAP: Record<number, { title: string; description: string }> = {
  413: {
    title: 'Files size limit exceeded',
    description:
      'The total size of the files you uploaded exceeds the limit of 20MB. Please try again with smaller files.',
  },
} as const
